// extracted by mini-css-extract-plugin
module.exports = {"login-wrapper":"Login_login-wrapper__1y9ZZ"};